import apiRequest from "src/utils/api-request";
import withApiPath from "src/utils/with-api-path";

export interface LatestTransactionSummary {
	id: number;
	status: string;
	type: string;
	transactionHash?: string;
}

export interface AdminOrder {
	id: number;
	uuid: string;
	merchantId: number;
	merchantName: string;
	merchantUserEmail?: string;
	merchantUserName?: string;
	merchantOrderId: string;
	status: string;
	fiatCurrency: string;
	fiatAmount: string;
	cryptoCurrency: string;
	cryptoAmount: string;
	paymentAddress: string;
	walletId: number;
	isTest: boolean;
	description?: string;
	receivedAmount: string;
	serviceFeeExpected: string;
	serviceFeeCollected: string;
	createdAt: string;
	updatedAt: string;
	expiresAt: string;
	latestTransaction?: LatestTransactionSummary;
}

export interface PaginatedOrdersResponse {
	orders: AdminOrder[];
	totalCount: number;
	limit: number;
	offset: number;
}

export interface ListOrdersParams {
	limit?: number;
	offset?: number;
	search?: string;
	status?: string;
	merchantId?: number;
	fiatCurrency?: string;
	cryptoCurrency?: string;
	isTest?: boolean;
}

const orderProvider = {
	async listOrders(
		params: ListOrdersParams = {},
	): Promise<PaginatedOrdersResponse> {
		const response = await apiRequest.get(withApiPath("/orders"), {
			params: {
				limit: params.limit ?? 50,
				offset: params.offset ?? 0,
				search: params.search ?? "",
				status: params.status ?? "",
				merchantId: params.merchantId ?? "",
				currency: params.fiatCurrency ?? "",
				cryptoCurrency: params.cryptoCurrency ?? "",
				isTest: typeof params.isTest === "boolean" ? String(params.isTest) : "",
			},
		});

		return response.data;
	},
};

export default orderProvider;
